import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { sxButtons, sxCloseIconButton, sxModal } from "./sxProps";
import { faCircleCheck } from "@fortawesome/pro-duotone-svg-icons";
import { useAccessibility } from "../../../../../../../Store/contexts/AccessibilityContext";
import PageTitle from "../../../../../../../components/Accessibility/PageTitle";
import DefaultText from "../../../../../../../components/Accessibility/DefaultText";
import DefaultButton from "../../../../../../../components/Accessibility/DefaultButton";
import { getMensagemPreAgenda } from "../../../../../../../services/SaudeBemEstar/GestaoDeCronicosService";
import { useGestaoDeCronicosCaptacao } from "../../../../context/CaptacaoContext";
import {
  GestaoDeCronicosStepsEnum,
  IResultIMC,
} from "../../../../../../../interfaces/enum/GestaoDeCronicosEnum";
import { useNavigate } from "react-router-dom";

interface Props {
  showModal: boolean;
  setShowEncerramentoModal: Dispatch<SetStateAction<boolean>>;
  codAcao: IResultIMC | undefined;
}

const EncerramentoModal: React.FC<Props> = ({
  showModal,
  setShowEncerramentoModal,
  codAcao,
}) => {
  const navigate = useNavigate()
  const accessibility = useAccessibility();
  const [message, setMessage] = useState({ textos: [] });
  const { handleChangeStep } = useGestaoDeCronicosCaptacao();

  useEffect(() => {
    getMensagemPreAgenda().then((response: any) => {
      if (response !== null && response !== undefined) setMessage(response);
    });
  }, []);

  const navigateHome = () => {
    navigate('/home')
    setShowEncerramentoModal(false);
  };

  return (
    <Modal open={showModal}>
      <Box
        sx={sxModal}
        style={{
          ...accessibility.textStyleAccessibility,
          ...accessibility.contrastBorderAccessibility,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={navigateHome}
          sx={sxCloseIconButton}
        >
          <FontAwesomeIcon
            icon={faTimes}
            size="1x"
            color="black"
            style={accessibility.textStyleAccessibility}
          />
        </IconButton>
        <FontAwesomeIcon icon={faCircleCheck} color="#00995D" size="3x" />
        <PageTitle
          marginBottom="15px"
          shouldFocus={false}
          text={
            codAcao?.codAcao === "CRONICO"
              ? "Queremos saber mais sobre você!"
              : "Obrigado por suas respostas!"
          }
        />
        {codAcao?.codAcao === "CRONICO" &&
          message.textos.map((texto, index) => (
            <DefaultText key={index} alignCenter text={texto} />
          ))}
        {codAcao?.codAcao !== "CRONICO" && (
          <DefaultText
            alignCenter
            text="Analisamos as suas respostas e identificamos que, neste momento, o
              seu caso não se enquadra nos critérios de elegibilidade.</br>
              Obrigado por ter preenchido o questionário e pelo seu interesse em
              participar.</br> Para que sua privacidade seja preservada, asseguramos
              que as informações pessoais que você nos enviou, ao responder o
              questionário, serão removidas do nosso banco de dados."
          />
        )}
        <Box sx={sxButtons}>
          {codAcao?.codAcao !== "CRONICO" && (
            <DefaultButton
              text="Voltar para início"
              onClick={navigateHome}
            />
          )}
          {codAcao?.codAcao === "CRONICO" && (
            <DefaultButton
              text="Continuar"
              onClick={() =>
                handleChangeStep(GestaoDeCronicosStepsEnum.agendarConsulta)
              }
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default EncerramentoModal;
